import crawlApi, { type CrawlRequestBody } from './crawlApi';

const detailApi = crawlApi.injectEndpoints({
  endpoints: build => ({
    getByUrl: build.query<unknown, CrawlRequestBody>({
      query: (body: CrawlRequestBody) => ({
        url: `/khazesh/v3/pages/get_by_url`,
        method: 'POST',
        body: body
      }),
      providesTags: ['UrlInfo']
    }),
    getDetailCount: build.query<unknown, CrawlRequestBody>({
      query: (body: CrawlRequestBody) => ({
        url: `/khazesh/v3/pages/get_details_count`,
        body: body,
        method: 'POST'
      })
    }),
    getInlinks: build.mutation<unknown, CrawlRequestBody>({
      query: (body: CrawlRequestBody) => ({
        url: `/khazesh/v3/pages/get_inlinks`,
        method: 'POST',
        body: body
      })
    }),
    getOutLinks: build.mutation<unknown, CrawlRequestBody>({
      query: (body: CrawlRequestBody) => ({
        url: `/khazesh/v3/pages/get_outlinks`,
        method: 'POST',
        body: body
      })
    }),
    getAssets: build.mutation<unknown, CrawlRequestBody>({
      query: (body: CrawlRequestBody) => ({
        url: `/khazesh/v3/pages/get_assets`,
        method: 'POST',
        body: body
      })
    }),
    getPageIssues: build.query<unknown, CrawlRequestBody>({
      query: (body: CrawlRequestBody) => ({
        url: `/khazesh/v3/pages/get_page_issues`,
        method: 'POST',
        body: body
      }),
      providesTags: ['PAGE_ISSUE']
    })
  }),
  overrideExisting: false
});

export const {
  useGetByUrlQuery,
  useGetInlinksMutation,
  useGetOutLinksMutation,
  useGetAssetsMutation,
  useLazyGetDetailCountQuery,
  useGetPageIssuesQuery
} = detailApi;
export default detailApi;
